import { loginReducer } from "../login/loginReducer";
import { toggleReducer } from "./toggleReducer";
import { formReducer } from "./formReducer";
import { eventReducer } from "../events/eventReducer";
import { loadingReducer } from "./loadingReducer";
import { combineReducers } from "redux-loop";
import { errorReducer } from "./errorReducer";
import { listEventsReducer } from "../events/listEvents/listEventsReducer";
import { userReducer } from "./userReducer";
import { certReducer } from "../certs/certReducer";
import { participantReducer } from "./participantReducer";

const rootReducer = combineReducers({
  loginState: loginReducer,
  formState: formReducer,
  toggleState: toggleReducer,
  eventState: eventReducer,
  loadingState: loadingReducer,
  errorState: errorReducer,
  listEventsState: listEventsReducer,
  userState: userReducer,
  certState: certReducer,
  participantState: participantReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
